import React from "react";
import CreatePost from "../components/CreatePost";

const Post = () => {
  return (
    <div className="w-full bg-gray-800 h-[150vh]">
      <CreatePost />
    </div>
  );
};

export default Post;
